import { render, staticRenderFns } from "./Type8.vue?vue&type=template&id=47572061&scoped=true"
import script from "./Type8.vue?vue&type=script&lang=js"
export * from "./Type8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47572061",
  null
  
)

export default component.exports